export const UNINITIALIZED_INITIATION_TYPE_ERROR =
  'Initiation type is not set. Please provide an initiation type when creating the messenger to call establishConnection()' as const;

export class UninitializedInitiationTypeError extends Error {
  constructor() {
    super(UNINITIALIZED_INITIATION_TYPE_ERROR);
    this.name = 'UninitializedInitiationTypeError';
  }
}
